import { render, staticRenderFns } from "./TopBtn.vue?vue&type=template&id=5c44bab4&scoped=true"
import script from "./TopBtn.vue?vue&type=script&lang=js"
export * from "./TopBtn.vue?vue&type=script&lang=js"
import style0 from "./TopBtn.vue?vue&type=style&index=0&id=5c44bab4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c44bab4",
  null
  
)

export default component.exports